import { useContext } from 'react';

import { FlagsContext } from 'apps/auth/firebase/FlagProvider';

export const useFlags = () => {
    return useContext(FlagsContext);
};
